import { render, staticRenderFns } from "./addMaterialImgOrThumbDialog.vue?vue&type=template&id=25500ee3"
import script from "./addMaterialImgOrThumbDialog.vue?vue&type=script&lang=js"
export * from "./addMaterialImgOrThumbDialog.vue?vue&type=script&lang=js"
import style0 from "./addMaterialImgOrThumbDialog.vue?vue&type=style&index=0&id=25500ee3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports